export default import.meta.ROLLDOWN_FILE_URL_Ztc2DAcd32aL6aTjnxoJSQ